import { render, staticRenderFns } from "./coordinate.vue?vue&type=template&id=1d1575f8&scoped=true"
import script from "./coordinate.vue?vue&type=script&lang=js"
export * from "./coordinate.vue?vue&type=script&lang=js"
import style0 from "./coordinate.vue?vue&type=style&index=0&id=1d1575f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1575f8",
  null
  
)

export default component.exports